// The platform's public address — the one place it is configured. Links the
// platform generates (the email sign-in link's continue URL) point here, so
// a student is always sent to the canonical domain.
//
//   VITE_PLATFORM_URL (no trailing slash) → that value;
//   unset in local dev → the page's own origin (http://localhost:5173), so
//     email-link sign-in keeps working against the Auth emulator;
//   unset in a production build → https://my.wannablab.com.
//
// The domain must be on Firebase Authentication → Authorized domains, or
// sending the link fails with auth/unauthorized-continue-uri.
export const DEFAULT_PLATFORM_URL = 'https://my.wannablab.com';

export const resolvePlatformUrl = ({ configured, dev, origin }) =>
    (String(configured || '').trim() || (dev && origin) || DEFAULT_PLATFORM_URL).replace(/\/+$/, '');

/** Read at call time (the page origin exists only in the browser). */
export const platformUrl = () =>
    resolvePlatformUrl({
        configured: import.meta.env.VITE_PLATFORM_URL,
        dev: import.meta.env.DEV,
        origin: typeof window !== 'undefined' ? window.location?.origin : '',
    });
